/**
 * High-Priority Payments — /sframe-204-s2/:estateId
 */

import { useParams } from 'react-router-dom';
import SettlementChecklistShell from '../../settlement/SettlementChecklistShell';

const FRAME_ID = 'sframe-204-s2';

const ITEMS = [
  {
    id: 'hi-1',
    title: 'Pay Administrative & Legal Fees',
    description:
      'Submit payment for attorney fees, court costs, appraiser bills, and executor compensation per state law.',
  },
  {
    id: 'hi-2',
    title: 'Settle Funeral & Burial Costs',
    description: 'Pay any outstanding funeral home, cremation, or burial plot invoices.',
  },
  {
    id: 'hi-3',
    title: 'Record Payment Confirmation',
    description: 'Save confirmation numbers, check images, or wire receipts for each payment made.',
  },
];

export default function PayDebts_HighPriority() {
  const { estateId } = useParams<{ estateId: string }>();

  if (!estateId) return <div className="p-8 text-stone-600 text-sm">Select an estate.</div>;

  return (
    <SettlementChecklistShell
      estateId={estateId}
      frameId={FRAME_ID}
      title="High-Priority Payments"
      backTo={`/sframe-204/${estateId}`}
      backLabel="← Pay Validated Debts"
      items={ITEMS}
      payDebtsHubKey="s2"
    />
  );
}
